import React, { useEffect } from "react";
import { Box, List, ListItem, IconButton, Typography, Divider, CircularProgress, Tooltip, Button, TextField, Switch, Grid } from "@mui/material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { accountActions } from "../../actions/account.action";

import { useNavigate } from "react-router-dom";

import axiosInstance from "../../interceptor/interceptor";

const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));
  

const AccountList = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [showCreate, setShowCreate] = React.useState(false);
    const [isCreditCard, setCreditCard] = React.useState(false);
    const accountList = useSelector((state) => state.accountReducer.accounts);
    const currency = localStorage.getItem('currency');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [inputField, setInputField] = React.useState({
        user_id: localStorage.getItem("user_text_obj_data1"),
        account_id: "",
        name: "",
      });

    const inputsHandler = (e) => {
      if (e.target.value.length <= 25) {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
      }
    }
    
    
    function moveBack(){
      navigate("/web");
    }

    useEffect(() => {
      fetchAccounts();
    }, []);


        useEffect(() => {
      if (showCreate === false) {
        setInputField({
          ...inputField,
          account_id: "",
          name: ""
        });
      }
    }, [showCreate]);

    // fetchAccounts
    function fetchAccounts() {
      try {
        const user_id = localStorage.getItem("user_text_obj_data1");
        dispatch(accountActions.fetchAccounts({ user_id: user_id }));
      } catch (e) {
        alert(e);
      }
    }
    function showEditForm(data){
      setInputField({
        account_id: data.account_id,
        name: data.name,
        user_id: localStorage.getItem("user_text_obj_data1"),
        account_type: data.account_type || 1,
      });
      setCreditCard(data.account_type == 2 ? true : false);
      setShowCreate(true);
    }

    const handleSubmit = async () => {
      try {
          setIsLoading(true);
          let account_type = 1;
          if(isCreditCard == true){
            account_type = 2;
          }
          const res = await axiosInstance.post(
            `api?method=add_account`,
            {name:inputField.name, user_id:inputField.user_id,account_id: inputField.account_id, account_type: account_type }
          );
          setCreditCard(false)
          setIsLoading(false);
          toast(res.data.message);
          setInputField({ ...inputField, name:"", account_id:"" });
          setShowCreate(false);
          setTimeout(()=>{
            dispatch(
              accountActions.fetchAccounts({
                user_id: localStorage.getItem("user_text_obj_data1")
              })
            );
          },0)
          
          
          
      } catch (e) {
        toast.info(`Error: ${e.response.data.messag1e || "Something went wrong"}`, { type: "error" });
      }
    };

      const accountArchiveHandler = async (account_id, status, msg) => {
        try {
          let result = window.confirm(msg);
          if (result) {
            setIsLoading(true);
            const res = await axiosInstance.post(
              `api?method=update_account_status`,
              { account_id: account_id, status: status }
            );
            setIsLoading(false);
            toast(res.data.message);
            setTimeout(()=>{
              dispatch(
                accountActions.fetchAccounts({
                  user_id: localStorage.getItem("user_text_obj_data1"),
                })
              );  
            }, 0);
    
          }
        } catch (e) {
          toast.info(`Error: ${e}`, { type: "error" });
        }
      };

  return (
    <>
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
        <Box className="tabpanel-data">
      <Box sx={{ width: "100%" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <h3 style={{ textAlign: "center", paddingLeft:"10px" }}>
            <Button className="top-nav-btn" variant="outlined">
                <KeyboardBackspaceRoundedIcon
                  onClick={moveBack}
                  style={{ cursor: "pointer", float: 'left',marginLeft: '10px !important' }}
                />
            </Button>
            
            Account List <AddCircleOutlineIcon style={{color:'blue', cursor:'pointer'}} onClick={()=>{ setShowCreate( !showCreate); }}/></h3>
            <Demo style={{ minHeight: "500px" }}>
                {showCreate===true ? (
                    <Grid className="tag-form-container">
                        <form className="tag-form" style={{margin:'0px 10px'}}>
                            <Box style={{fontWeight:'500', padding:'10px 0px'}}>{inputField.account_id && inputField.account_id!=""  ? (<>Update</>):(<>Add New</>)} Account</Box>
                            <Box>
                              <TextField
                                  value={inputField.name}
                                  onChange={inputsHandler}
                                  style={{ marginBottom: "10px", width: "100%" }}
                                  type="text"
                                  label="Name"
                                  variant="outlined"
                                  name="name"
                                  maxLength={25}
                              />
                              </Box>
                              <Box style={{ height: "40px"}}>
                              <Switch
                                onChange={() => setCreditCard(!isCreditCard)}
                                checked={isCreditCard}
                              />
                              Is a Credit Card ?
                            </Box>
                            <Box style={{ height: "40px"}}>
                              <Button className="fl-rt" onClick={handleSubmit} variant="outlined">Save</Button>
                            </Box>
                            
                        </form>
                        
                    </Grid>
                ): (
                <></>
                )}
              {accountList ? (
                <List>
                  {accountList.length > 0 ? accountList.map((data, index) => (
                    <div key={index}>
                      <ListItem
                        secondaryAction={
                          <>
                            <IconButton style={{marginRight:'0px'}}
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                 (data.budget_id)
                              }
                            >
                              <Tooltip title="Edit Account">
                                <EditIcon onClick={()=> { showEditForm(data) }} />
                              </Tooltip>
                              
                            </IconButton>
                            {data.is_archived == '0' ? (
                              <IconButton style={{color:'green'}}
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                accountArchiveHandler(data.account_id, "1", "Sure to archive?")
                              }
                            >
                                <Tooltip title="Click to Archive">
                                  <ArchiveOutlinedIcon />
                                </Tooltip>                              
                              </IconButton>
                            ): (
                              <IconButton style={{color:'red'}}
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                accountArchiveHandler(data.account_id, "0", "Sure to unarchive?")
                              }
                            >
                              <Tooltip title="Click to Unarchive">
                                <UnarchiveOutlinedIcon />
                              </Tooltip>                              
                              </IconButton>
                            )}
                            
                          </>
                        }
                      >
                        <div className="content_budget">
                          <h4>
                            {index+1}. {data.name}
                          </h4>
                         

                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  )): <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                  No Data Available
              </Box>}
                </List>
              ) : (
                <>
                  {/* <div id="overlay">
                    <div className="loader">
                      <CircularProgress />
                    </div>
                  </div> */}
                </>
              )}
            </Demo>
          </Grid>
        </Grid>
      </Box>
    </Box>
        </Grid>
      </Grid>

    </>
  );
};

export default AccountList;
